import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Col, Button, Row } from 'reactstrap';
import { Field, } from 'redux-form';
import TextField from '@material-ui/core/TextField';
import moment from 'moment';
import history from '../../../../../../history';
import PrintIcon from '@material-ui/icons/Print';
import PrintsProceduresPDF from '../PrintsProceduresPDF';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import SelectorTemplate from '../SelectorTemplate';
import renderFileInputField from '../../../../../../shared/components/form/FileInput';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFile, faTrashAlt } from "@fortawesome/free-solid-svg-icons";
import Tooltip from '@material-ui/core/Tooltip';

const renderField = ({
  input, placeholder, type, meta: { touched, error },
}) => (
  <div className="form__form-group-input-wrap form__form-group-input-wrap--error-above">
    <input {...input} placeholder={placeholder} type={type} />
    {touched && error && <span className="form__form-group-error">{error}</span>}
  </div>
);

renderField.propTypes = {
  input: PropTypes.shape().isRequired,
  placeholder: PropTypes.string,
  type: PropTypes.string,
  meta: PropTypes.shape({
    touched: PropTypes.bool,
    error: PropTypes.string,
  }),
};

renderField.defaultProps = {
  placeholder: '',
  meta: null,
  type: 'text',
};

class Holter extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      dataMedications: [],
      specialists: [],
      specialty: '',
      professionals: [],
      professional: {},
      //professional: [],
      MedicalProcedures: {},
      addedDiagnostics: [],
      openModal: false,
      conclusion: "",
      loadProfessionals: false,
      profile: sessionStorage.getItem('perfil'),
      holterFiles: []
    }
  }

  componentDidMount() {
    console.log(this.props);
    if (this.props.professional === "") {
      //this.getData();
      this.getDataIndividually();
    }
  }

  checkForFilesByThisProcedure = () => {
    let holterFiles = this.props.filesProcedures.filter((file) => file.procedure === 'Holter');
    this.setState({ holterFiles })
  }

  /* componentDidUpdate(prevProps) {
    if (JSON.stringify(prevProps.filesProcedures) !== JSON.stringify(this.props.filesProcedures))
      this.checkForFilesByThisProcedure()
  }
 */

  getDataIndividually = () => {

    this.setState({ loadProfessionals: true }, async () => {
      let specialistList = await this.fetchDataSpecialist();
      let professionales = await this.fetchDataProfessionals();
      console.log("specialistList", specialistList, "professionales", professionales);
      if (!!specialistList && this.props.id_professionalFromEvent !== null) {
        let id_specialty = "";
        professionales.map((professional) => {
          if (professional.id_profesional === this.props.id_professionalFromEvent) {
            id_specialty = professional.id_especialidad
          }
        });
        this.setState({ specialty: id_specialty }, () => {
          this.setState({ professional: this.props.professional, loadProfessionals: false });
          this.props.handlerMedicalProcedures("Holter", "professional", this.props.professional);
        });
      }
    })
  }

  getData = () => {
    this.setState({ loadProfessionals: true }, () => {
      Promise.all([this.fetchDataSpecialist(), this.fetchDataProfessionals()]).then((result) => {
        this.setState({ specialists: result[0], professionals: result[1] }, () => {
          if (this.props.professional != null) {
            var id_specialty = "";
            result[1].map((professional) => {
              if (professional.id_profesional === this.props.professional) {
                id_specialty = professional.id_especialidad
              }
            });
            this.setState({ specialty: id_specialty, professional: this.props.professional, loadProfessionals: false }, () => {
              //this.props.handlerMedicalProcedures("Holter", "professional", this.props.professional);
            });
          }
        });
      })
        .catch(error => console.log(`Error in promises ${error}`));
    })
  }

  fetchDataSpecialist = () => {
    return new Promise((resolve, reject) => {
      fetch(process.env.REACT_APP_PUBLIC_URL + 'especialidad/listar', {
        method: 'GET',
        headers: {
          authorization: 'Bearer ' + sessionStorage.getItem('token'),
        }
      })
        .then(response => {
          return response.json();
        })
        .then(specialists => {
          resolve(specialists);
        })
        .catch((error) => {
          reject(error)
        });
    });
  };

  fetchDataProfessionals = () => {
    return new Promise((resolve, reject) => {
      fetch(process.env.REACT_APP_PUBLIC_URL + 'profesional/listar', {
        method: 'GET',
        headers: {
          authorization: 'Bearer ' + sessionStorage.getItem('token'),
        }
      })
        .then(response => {
          return response.json();
        })
        .then(professionals => {
          resolve(professionals);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };


  handlerSpeciality = (event) => {
    this.setState({ specialty: event.target.value });
  }

  handlerProfessional = (professional) => {
    this.setState({ professional: professional });
  }

  handlerConclusion = (conclusion) => {
    this.setState({ conclusion: conclusion });
  }

  printPDF = async () => {
    await this.props.saveProceduresPatient().then((saved) => {
      if (saved) {
        PrintsProceduresPDF.printPDF(this.props.id_admision, "HOLTER");
      }
    }).catch((err) => {
      console.log(err);
    })
  }

  onChangeTemplate = (template) => {
    if (template != null && template != undefined) {
      this.props.handlerMedicalProcedures("Holter", "conclusion", template.contenido, "nameTemplete", template.plantilla);
      //this.props.handlerNameTemplete("Holter", "nameTemplete", template.plantilla);
      this.handlerConclusion(template.contenido);
    }
  }

  handlerTextfieldFileProcedure = (e) => {
    console.log("WHATISTHISndTime", e);
    this.props.handlerFileProcedure(e.target.files[0], this.props.dataProcedure.id_servicio);
    //this.inputFileTestRef.current.value = null
  }

  render() {
    return (<Col>
      <div className="form" style={{ flex: 1, flexDirection: 'column' }}>
        <div className="card__title">
          <h5 className="bold-text">Holter </h5>
        </div>

        <Row>
          <Col md={6}>
            <SelectorTemplate
              typeProcedure={6}
              onChangeTemplate={(template) => {
                this.onChangeTemplate(template);
              }}
              disabled={this.props.isCloseClinicHistory}
            />
          </Col>
        </Row>
        <br />

        <div style={{ flex: 1, flexDirection: 'row', marginBottom: 20 }}>
          <TextField
            required
            disabled
            id="specilaity-standard-required"
            label="Especialidad"
            type="text"
            value={typeof this.props.professional.especialidad === 'undefined' ? "" : this.props.professional.especialidad}
            onChange={(e) => {
              this.handlerSpeciality(e.target.value);
            }}
          />
          <TextField
            required
            disabled
            id="professional-standard-required"
            label="Profesional"
            type="text"
            value={`${this.props.professional.nombres} ${this.props.professional.apellido1}`}
            onChange={(e) => {
              this.handlerProfessional(e.target.value);
            }}
          />
        </div>
        {/* <div className="form__form-group">
          <span className="form__form-group-label">Conclusión</span>
          <div className="form__form-group-field">
            <Field
              name="textarea-conclusion-HOLTER"
              component="textarea"
              placeholder=""
              defaultValue={this.props.dataProcedure.conclusion}
              disabled={this.props.isCloseClinicHistory}
              onChange={(e) => {
                this.props.handlerMedicalProcedures("Holter", "conclusion", e.target.value);
                this.handlerConclusion(e.target.value)
              }}
            />
          </div>
        </div> */}
        <div style={{ margin: 10 }}>
          <CKEditor
            style={{ width: '100%', height: '200px' }}
            editor={ClassicEditor}
            disabled={this.props.isCloseClinicHistory}
            data={this.props.dataProcedure.conclusion != null ? this.props.dataProcedure.conclusion : ''}
            onChange={(event, editor) => {
              const data = editor.getData();
              this.props.handlerMedicalProcedures("Holter", "conclusion", data);
              this.handlerConclusion(data)
            }}
          />
        </div>
      </div>
      <Button
        style={{ marginTop: 20 }}
        color="primary"
        disabled={this.props.isCloseClinicHistory}
        onClick={() => { this.printPDF() }}
      >
        Guardar e Imprimir
      </Button>

      {!!this.props.dataProcedure.holterFiles &&
        !!this.props.dataProcedure.holterFiles.length ?
        this.props.dataProcedure.holterFiles.map(holterFile => (
          <div style={{ margin: '0em 2em' }} key={holterFile.id_procedimiento_adjunto}>
            <div>
              <b>{holterFile.adjunto}</b>
            </div>
            <Tooltip title="Ver Documento">
              <Button
                className="btn btn-sm"
                color="primary"
                onClick={() => {
                  window.open(holterFile.wholeUrl, '_blank');
                }}
              >
                <FontAwesomeIcon icon={faFile} />
              </Button>
            </Tooltip>
            <Tooltip title="Eliminar Documento">
              <Button
                className="btn btn-sm"
                color="danger"
                onClick={() => {
                  this.props.deleteFileProcedure(holterFile.id_admision, holterFile.id_servicio, holterFile.procedure);
                }}
              >
                <FontAwesomeIcon icon={faTrashAlt} />
              </Button>
            </Tooltip>
          </div>
        ))
        : <div>
          <span className="form__form-group-label">
            Agregar adjunto
          </span>
          <div >
            <TextField
              id="file-procedure-holter-standard-required"
              type="file"
              variant="outlined"
              className="material-form__field"
              //ref={this.inputFileTestRef}
              inputProps={{
                multiple: false
              }}
              onChange={(e) => {
                this.handlerTextfieldFileProcedure(e);
              }}
            />
            {/* <Field
              name="file-medical-procedure"
              component={renderFileInputField}
              onChange={(e) => {
                console.log("WHATISHERE", e)
                this.props.handlerFileProcedure(e, this.props.dataProcedure.id_servicio)
              }}
            /> */}
          </div>
        </div>}
    </Col>);
  }
}

export default Holter;